module.exports = __webpack_public_path__ + "img/energy-tower.6231de48.png";